import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { makeStyles, Typography, Box, Grid } from "@material-ui/core";

import { Icon } from "../base";
import { ShaDowBox } from "../boxes";
import { NoDataCard } from "./noDataCard";
import { COLORS } from "../../theme/colors";
import clockImg from "../../assets/images/icons/clock.svg";
import happyImg from "../../assets/images/icons/happy.svg";
import tenantImg from "../../assets/images/icons/tenant.svg";
import unpaidImg from "../../assets/images/icons/unpaid.svg";
import dollarImg from "../../assets/images/icons/dollar.svg";
import { currencyFormatter, onlyZeroValuesInArray } from "../../services";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    width: 85,
    height: 85,
    backgroundColor: COLORS.darks[0][3],
    borderRadius: "50%",
  },
  textBlock: {
    marginLeft: 20,
  },
  link: {
    textDecoration: "none",
    color: COLORS.blue,
  },
  noDebt: {
    marginTop: 32,
    padding: theme.spacing(3),
    display: "flex",
    alignItems: "center",
  },
  noDebtText: {
    fontSize: 48,
    fontWeight: 700,
  },
  noDebtSpan: {
    marginLeft: theme.spacing(0.5),
    fontSize: 18,
    fontWeight: 400,
  },
}));

export const UnpaidElectricityBills = ({ data, type }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  const getFirstBlockText = () => {
    switch (type) {
      case "tenant":
        return "Tenant's total electricity debt";
      case "unit":
        return "Unit's total electricity debt";
      default:
        return "Building's total electricity debt";
    }
  };

  const getSecondBlockText = () => {
    switch (type) {
      case "tenant":
      case "unit":
        return "Unpaid Bill";
      default:
        return "Tenants have electricity debts";
    }
  };

  if (!data.length) {
    return <NoDataCard title="Unpaid Electricity Bills" rootStyle={{ marginTop: 30 }} />;
  }

  if (onlyZeroValuesInArray(data.map((item) => item.value))) {
    return (
      <ShaDowBox>
        <Box className={classes.noDebt}>
          <Icon src={happyImg} style={{ margin: "0 26px" }} />
          <Typography className={classes.noDebtText}>
            PERFECT!
            <Typography component="span" className={classes.noDebtSpan}>
              All Electricity Bills are Paid
            </Typography>
          </Typography>
        </Box>
      </ShaDowBox>
    );
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: "24px 24px 67px", marginTop: 30 }}>
        <Typography variant="h4">Unpaid Electricity Bills</Typography>
        <Grid container style={{ marginTop: 42 }}>
          <Grid container item xs={6} alignItems="center" style={{ paddingLeft: 24 }}>
            <Box className={classes.box}>
              <Icon src={clockImg} />
            </Box>
            <Box className={classes.textBlock}>
              <Typography variant="h4" style={{ color: COLORS.red }}>
                {currencyFormatter(data[0].value, currencySymbol)} {getFirstBlockText()}
              </Typography>
              <Link to="" className={classes.link}>
                Show more
              </Link>
            </Box>
          </Grid>
          <Grid container item xs={6} alignItems="center">
            <Box className={classes.box}>
              {type === "building" ? (
                <Icon
                  src={tenantImg}
                  style={{
                    width: 25,
                  }}
                />
              ) : (
                <Icon
                  src={unpaidImg}
                  style={{
                    marginLeft: 5,
                  }}
                />
              )}
              <Icon
                src={dollarImg}
                style={{
                  position: "absolute",
                  top: 20,
                  left: type === "building" ? 54 : 30,
                }}
              />
            </Box>
            <Box className={classes.textBlock}>
              <Typography variant="h4" style={{ color: COLORS.red }}>
                {data[1].value || 0} {getSecondBlockText()}
              </Typography>
              <Typography>{data[1]?.description}</Typography>
              <Link to="" className={classes.link}>
                Show more
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};

UnpaidElectricityBills.defaultProps = {
  data: [],
  type: "building",
};
